import { render, staticRenderFns } from "./BookLayout.vue?vue&type=template&id=35e6301a&lang=pug&"
import script from "./BookLayout.vue?vue&type=script&lang=js&"
export * from "./BookLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports